/**
 * 赛事详情页面
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { competitionConfig } from '../config';

const Details: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 animate-in slide-in-from-bottom-4 duration-500">
      <div className="text-center mb-12">
        <div className="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-600 text-xs font-bold mb-4 uppercase tracking-widest">AI SCENE MASTER ENTRY</div>
        <h1 className="text-3xl font-extrabold text-blue-900 mb-4">OPC 创新实践赛实施方案</h1>
        <p className="text-slate-500 italic font-medium">—— AI 场景大师平台专属通道 ——</p>
      </div>

      <div className="space-y-12 prose prose-slate max-w-none">
        {/* Highlight Note */}
        <div className="bg-amber-50 border-l-4 border-amber-400 p-6 rounded-r-2xl">
          <h4 className="text-amber-800 font-bold m-0 mb-2">💡 平台提示</h4>
          <p className="text-amber-700 text-sm m-0 leading-relaxed">
            本报名入口专为通过 <b>AI 场景大师</b> 平台参与赛事的学生设计。参赛者将优先获得平台智能体培育权限，并可享受平台提供的专属技术咨询与案例库支持。
          </p>
        </div>

        {/* Background */}
        <section>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 rounded bg-blue-600 text-white flex items-center justify-center font-bold">1</div>
            <h2 className="text-xl font-bold m-0 text-slate-800">活动背景</h2>
          </div>
          <p className="text-slate-600 leading-relaxed">
            为贯彻落实《苏州市人工智能 OPC 培育发展行动计划(2025-2028 年)》,培育新型人工智能创新人才,苏州市教育局特举办中小学人工智能线上冬令营活动。
            其中,OPC 创新实践赛旨在引导小学、初中、高中、中职、高职学生利用 AI 智能体技术,探索教育教学场景的创新应用。
          </p>
        </section>

        {/* Positioning */}
        <section>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 rounded bg-blue-600 text-white flex items-center justify-center font-bold">2</div>
            <h2 className="text-xl font-bold m-0 text-slate-800">赛事定位</h2>
          </div>
          <p className="text-slate-600 leading-relaxed">
            利用 <b>AI 场景大师</b> 提供的智能体培育平台,开发具有实用价值的 AI 应用场景。
            比赛强调"以赛促学、以赛促用、以赛促创",引导学生在真实场景中探索 AI 技术的应用潜力。
          </p>
        </section>

        {/* Timeline - UPDATED */}
        <section>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 rounded bg-blue-600 text-white flex items-center justify-center font-bold">3</div>
            <h2 className="text-xl font-bold m-0 text-slate-800">赛程安排</h2>
          </div>
          <div className="relative border-l-2 border-blue-200 ml-4 space-y-10 pl-8">
            <div className="relative">
              <div className="absolute -left-[41px] top-1 w-4 h-4 rounded-full bg-blue-600 border-4 border-white"></div>
              <h4 className="font-bold text-blue-900 m-0 text-lg">赛事报名阶段</h4>
              <p className="text-sm font-bold text-blue-500 mb-2">
                2026年1月26日 — {new Date(competitionConfig.registrationDeadline).toLocaleDateString('zh-CN', { month: 'long', day: 'numeric' })}
              </p>
              <p className="text-sm text-slate-600 leading-relaxed">
                学生及指导老师需在 AI 场景大师平台完成实名注册与报名信息提交。请务必在截止日期前完成报名，以免错过参赛机会。
              </p>
            </div>
            <div className="relative">
              <div className="absolute -left-[41px] top-1 w-4 h-4 rounded-full bg-slate-200 border-4 border-white"></div>
              <h4 className="font-bold text-slate-800 m-0 text-lg">启动培训、线上实操与测评</h4>
              <p className="text-sm font-bold text-emerald-600 mb-2">
                {competitionConfig.trainingStartDate.replace(/-/g, '年').replace(/-/g, '月')}日 — {competitionConfig.trainingEndDate.replace(/-/g, '年').replace(/-/g, '月')}日
              </p>
              <p className="text-sm text-slate-600 leading-relaxed">
                包含专家直播授课、AI 智能体开发实践以及最终的线上作品测评。参赛者需在此期间基于平台完成智能体作品的开发与发布。
              </p>
            </div>
          </div>
        </section>

        {/* Objects */}
        <section>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 rounded bg-blue-600 text-white flex items-center justify-center font-bold">4</div>
            <h2 className="text-xl font-bold m-0 text-slate-800">参赛对象</h2>
          </div>
          <div className="bg-slate-100 p-6 rounded-2xl">
            <ul className="list-disc pl-5 space-y-2 text-slate-600 m-0">
              <li>在校学生：{competitionConfig.studentLevels.join('、')}</li>
              <li>形式：个人或团队(团队人数不超过 3 人)</li>
              <li>要求：每个参赛项目需配备 1 名指导教师</li>
            </ul>
          </div>
        </section>

        {/* Tracks */}
        <section>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 rounded bg-blue-600 text-white flex items-center justify-center font-bold">5</div>
            <h2 className="text-xl font-bold m-0 text-slate-800">评审赛道</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="border border-slate-200 rounded-2xl p-6 bg-white shadow-sm hover:border-blue-200 transition-all text-center">
              <h3 className="font-bold text-blue-700 mb-2 m-0">创新赛道</h3>
              <p className="text-xs text-slate-400 italic">侧重算法与技术突破</p>
            </div>
            <div className="border border-slate-200 rounded-2xl p-6 bg-white shadow-sm hover:border-emerald-200 transition-all text-center">
              <h3 className="font-bold text-emerald-700 mb-2 m-0">创意赛道</h3>
              <p className="text-xs text-slate-400 italic">侧重教学应用场景</p>
            </div>
            <div className="border border-slate-200 rounded-2xl p-6 bg-white shadow-sm hover:border-amber-200 transition-all text-center">
              <h3 className="font-bold text-amber-700 mb-2 m-0">创业赛道</h3>
              <p className="text-xs text-slate-400 italic">侧重社会价值与落地</p>
            </div>
          </div>
        </section>
      </div>

      <div className="mt-16 pt-8 border-t border-slate-200 flex flex-col items-center">
        <p className="text-slate-500 mb-6 italic">AI 场景大师技术支持中心 | 2026 年 1 月</p>
        <Link to="/register" className="bg-blue-600 text-white px-12 py-4 rounded-full font-bold shadow-xl hover:bg-blue-700 transform hover:scale-105 transition-all">
          立即开始报名
        </Link>
      </div>
    </div>
  );
};

export default Details;
